export const toLocalStorage = (name: string, value: string) => {
  localStorage.setItem(name, value);
};

export const getFromLocalStorage = (name: string) => {
  return localStorage.getItem(name);
};

export const removeFromLocalStorage = (name: string) => {
  localStorage.removeItem(name);
};

export const getAndRemoveLocalStorage = (name: string) => {
  const item = getFromLocalStorage(name);
  removeFromLocalStorage(name);
  return item;
};
